<template>
  <div class="form-process">
    <b-field
      label="Nombre del Proceso"
      :type="nameError ? 'is-danger' : null"
      :message="nameError"
    >
      <b-input
        v-model="form.name"
        placeholder="Ingresa el nombre del proceso"
        @input="touched.name = true"
        @blur="touched.name = true"
        autofocus
      ></b-input>
    </b-field>

    <b-field
      label="Fecha de creación"
      :type="evaluationDateError ? 'is-danger' : null"
      :message="evaluationDateError"
    >
      <b-datepicker
        v-model="form.evaluationDate"
        class="datepicker-in-modal"
        placeholder="Haga clic para seleccionar..."
        icon="calendar-today"
        icon-right-clickable
        :icon-right="form.evaluationDate ? 'close-circle' : ''"
        @icon-right-click="clearDate"
        @input="touched.evaluationDate = true"
        @blur="touched.evaluationDate = true"
        trap-focus
      >
      </b-datepicker>
    </b-field>

    <b-field label="Opciones">
      <b-checkbox v-model="form.test" type="is-success">
        Esto es una prueba?
      </b-checkbox>

      <b-tooltip
        label="No se incluirá para el contexto"
        type="is-dark is-light"
        position="is-right"
        class="cultura-tooltip"
      >
        <div class="is-flex is-justify-content-space-between">
          <b-icon icon="information-outline" size="is-small"> </b-icon>
        </div>
      </b-tooltip>
    </b-field>

    <div class="actions">
      <b-button
        icon-left="refresh"
        :disabled="!hasChanges"
        @click="handleReset"
      >
        Restablecer
      </b-button>
      <b-button
        type="is-primary"
        icon-left="content-save"
        :disabled="!hasChanges"
        @click="handleSubmitProcess"
      >
        Guardar Cambios
      </b-button>
    </div>
  </div>
</template>

<script>
// Store
import { updateProcess } from "../../api";
import store from "../../store";

export default {
  name: "Process",
  data() {
    return {
      form: {
        ...store.state.selectedProcess,
        evaluationDate: new Date(store.state.selectedProcess.evaluationDate),
      },
      touched: {
        name: false,
        evaluationDate: false,
        test: false,
      },
    };
  },
  props: {
    hasChanges: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    currentProcess() {
      return store.state.selectedProcess;
    },
    // Validate Form
    nameError() {
      if (!this.touched.name) return null;
      if (!this.form.name) return "Campo obligatorio";
      return null;
    },
    evaluationDateError() {
      if (!this.touched.evaluationDate) return null;
      if (!this.form.evaluationDate) return "Campo obligatorio";
      return null;
    },
    isFormValid() {
      const noErrors = !this.nameError && !this.evaluationDate;
      const allFilled =
        this.form.name.trim() !== "" &&
        !!this.form.evaluationDate &&
        (this.form._id
          ? !this.isEqualObjects(this.currentProcess, this.form)
          : true);

      return noErrors && allFilled;
    },
  },
  methods: {
    // Form
    clearForm() {
      this.form = {
        ...this.currentProcess,
        evaluationDate: new Date(this.currentProcess.evaluationDate),
      };
      this.touched = {
        name: false,
        evaluationDate: false,
        test: false,
      };
    },
    clearDate() {
      this.form.evaluationDate = null;
    },
    isEqualObjects(obj1, obj2) {
      return (
        JSON.stringify(obj1, Object.keys(obj1).sort()) ===
        JSON.stringify(obj2, Object.keys(obj2).sort())
      );
    },
    // Actions
    handleSubmitProcess() {
      if (!this.isFormValid) return;
      updateProcess(this.form)
        .then(async (res) => {
          delete res.idClient;
          store.dispatch("selectProcess", { ...this.form, ...res });
          this.handleChange(false);
          this.$store.dispatch("notify", {
            message: "Proceso actualizado correctamente.",
            type: "is-success",
          });
        })
        .catch((err) => {
          console.log(err);
          this.$store.dispatch("notify", {
            message: "Error al actualizar el proceso.",
            type: "is-danger",
          });
        });
    },
    handleChange(value = null) {
      this.$emit("handleChange", value);
    },
    handleReset() {
      this.clearForm();
      this.handleChange(false);
    },
  },
  watch: {
    form: {
      handler() {
        this.handleChange(!this.isEqualObjects(this.currentProcess, this.form));
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
.actions {
  display: flex;
  margin-top: 1rem;
  align-items: center;
  justify-content: end;
  width: 100%;
  gap: 0.5rem;
}

.form-process .field {
  margin-bottom: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/cultura/sections/configuration/Process.vue